import React, { useState, useEffect } from 'react';
import Navbar from '../components/Navbar';

function ContentStudio() {
  const [posts, setPosts] = useState([]);
  const [channels, setChannels] = useState([]);
  const [stats, setStats] = useState({ pending: 0, approved: 0, rejected: 0 });
  const [categories, setCategories] = useState([]);
  const [filter, setFilter] = useState('pending');
  const [loading, setLoading] = useState(true);
  const [editingId, setEditingId] = useState(null);
  const [editTitle, setEditTitle] = useState('');
  const [editContent, setEditContent] = useState('');
  const [showComposer, setShowComposer] = useState(false);
  const [newTitle, setNewTitle] = useState('');
  const [newContent, setNewContent] = useState('');
  const [selectedChannel, setSelectedChannel] = useState('');
  const [creating, setCreating] = useState(false);

  const getToken = () => localStorage.getItem('accessToken');
  const headers = { Authorization: `Bearer ${getToken()}` };

  useEffect(() => {
    fetchMe();
    fetchPosts();
    fetchStats();
    fetchChannels();
  }, [filter]);

  const fetchMe = async () => {
    try {
      const res = await fetch('/api/content-studio/me', { headers });
      const data = await res.json();
      setCategories(data.channels || []);
    } catch (e) {}
  };

  const fetchPosts = async () => {
    setLoading(true);
    try {
      const res = await fetch(`/api/content-studio/posts?status=${filter}`, { headers });
      const data = await res.json();
      setPosts(data.posts || []);
    } catch (e) {}
    setLoading(false);
  };

  const fetchStats = async () => {
    try {
      const res = await fetch('/api/content-studio/stats', { headers });
      const data = await res.json();
      setStats(data);
    } catch (e) {}
  };

  const fetchChannels = async () => {
    try {
      const res = await fetch('/api/content-studio/channels', { headers });
      const data = await res.json();
      setChannels(data.channels || []);
    } catch (e) {}
  };

  const handleApprove = async (postId) => {
    await fetch(`/api/content-studio/posts/${postId}/approve`, { method: 'POST', headers });
    fetchPosts(); fetchStats();
  };

  const handleReject = async (postId) => {
    if (!window.confirm('Reject this post?')) return;
    await fetch(`/api/content-studio/posts/${postId}/reject`, { method: 'POST', headers });
    fetchPosts(); fetchStats();
  };

  const handleEdit = async (postId) => {
    if (editContent.trim().length < 50) { alert('Content must be at least 50 characters'); return; }
    await fetch(`/api/content-studio/posts/${postId}/edit`, {
      method: 'PUT', headers: { ...headers, 'Content-Type': 'application/json' },
      body: JSON.stringify({ content: editContent, title: editTitle || null })
    });
    setEditingId(null); setEditTitle(''); setEditContent('');
    fetchPosts(); fetchStats();
  };

  const handleCreate = async () => {
    if (!selectedChannel) { alert('Select a channel'); return; }
    if (newContent.trim().length < 50) { alert('Content must be at least 50 characters'); return; }
    setCreating(true);
    try {
      const res = await fetch('/api/content-studio/posts/create', {
        method: 'POST', headers: { ...headers, 'Content-Type': 'application/json' },
        body: JSON.stringify({ content: newContent, title: newTitle || undefined, channelId: parseInt(selectedChannel) })
      });
      const data = await res.json();
      if (res.ok) {
        alert('Post created and published!');
        setNewTitle(''); setNewContent(''); setSelectedChannel(''); setShowComposer(false);
        fetchPosts(); fetchStats();
      } else {
        alert(data.error || 'Failed to create');
      }
    } catch (e) { alert('Error: ' + e.message); }
    setCreating(false);
  };

  return (
    <div>
      <Navbar />
      <div style={{ maxWidth: '900px', margin: '0 auto', padding: '24px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
          <h1>🌱 Content Studio</h1>
          <button onClick={() => setShowComposer(!showComposer)} style={{ padding: '10px 20px', borderRadius: '8px', border: 'none', background: '#7c3aed', color: '#fff', cursor: 'pointer', fontWeight: 600 }}>
            {showComposer ? '✕ Close' : '+ Create Post'}
          </button>
        </div>
        <p style={{ color: '#6b7280', marginBottom: '16px' }}>
          Your channels: {categories.map(c => c.channel_name).join(', ') || 'Loading...'}
        </p>

        {showComposer && (
          <div style={{ border: '1px solid #e5e7eb', borderRadius: '12px', padding: '20px', marginBottom: '24px', background: '#fafafa' }}>
            <h3 style={{ marginBottom: '12px' }}>Create a new Community Resource post</h3>
            <select value={selectedChannel} onChange={(e) => setSelectedChannel(e.target.value)} style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #d1d5db', marginBottom: '12px' }}>
              <option value="">Select channel...</option>
              {channels.map(ch => <option key={ch.channel_id} value={ch.channel_id}>{ch.name} ({ch.category_name})</option>)}
            </select>
            <input type="text" value={newTitle} onChange={(e) => setNewTitle(e.target.value)} placeholder="Post title (e.g., How I manage ADHD at work)" maxLength={200} style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #d1d5db', marginBottom: '12px', fontSize: '15px', fontWeight: 500 }} />
            <textarea value={newContent} onChange={(e) => setNewContent(e.target.value)} placeholder="Write your post here... Share your experience, tips, or insights for this community." style={{ width: '100%', minHeight: '200px', padding: '12px', borderRadius: '8px', border: '1px solid #d1d5db', fontFamily: 'inherit', fontSize: '14px', lineHeight: '1.6', resize: 'vertical' }} />
            <div style={{ display: 'flex', gap: '8px', marginTop: '12px' }}>
              <button onClick={handleCreate} disabled={creating} style={{ padding: '10px 20px', borderRadius: '8px', border: 'none', background: '#10b981', color: '#fff', cursor: 'pointer' }}>
                {creating ? 'Publishing...' : 'Publish as Community Resource'}
              </button>
              <button onClick={() => setShowComposer(false)} style={{ padding: '10px 20px', borderRadius: '8px', border: '1px solid #d1d5db', background: '#fff', cursor: 'pointer' }}>Cancel</button>
            </div>
          </div>
        )}

        <div style={{ display: 'flex', gap: '12px', marginBottom: '20px' }}>
          {['pending', 'approved', 'rejected'].map(s => (
            <button key={s} onClick={() => setFilter(s)} style={{ padding: '8px 16px', borderRadius: '8px', border: 'none', cursor: 'pointer', background: filter === s ? '#7c3aed' : '#f3f4f6', color: filter === s ? '#fff' : '#374151', fontWeight: 500 }}>
              {s.charAt(0).toUpperCase() + s.slice(1)} ({stats[s] || 0})
            </button>
          ))}
        </div>

        {loading ? <p>Loading...</p> : posts.length === 0 ? (
          <p style={{ color: '#9ca3af', textAlign: 'center', padding: '40px' }}>No {filter} posts in your categories</p>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            {posts.map(post => (
              <div key={post.post_id} style={{ border: '1px solid #e5e7eb', borderRadius: '12px', padding: '20px', background: '#fff' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '12px' }}>
                  <div>
                    <span style={{ fontSize: '13px', background: '#ede9fe', color: '#7c3aed', padding: '3px 8px', borderRadius: '6px' }}>{post.channel_name}</span>
                    <span style={{ fontSize: '12px', color: '#9ca3af', marginLeft: '8px' }}>{new Date(post.created_at).toLocaleDateString()}</span>
                    {post.human_edited && <span style={{ fontSize: '11px', background: '#fef3c7', color: '#d97706', padding: '2px 6px', borderRadius: '4px', marginLeft: '8px' }}>Edited</span>}
                  </div>
                </div>
                {editingId === post.post_id ? (
                  <div>
                    <input type="text" value={editTitle} onChange={(e) => setEditTitle(e.target.value)} placeholder="Post title (optional)" maxLength={200} style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #d1d5db', marginBottom: '8px', fontSize: '15px', fontWeight: 500 }} />
                    <textarea value={editContent} onChange={(e) => setEditContent(e.target.value)} style={{ width: '100%', minHeight: '200px', padding: '12px', borderRadius: '8px', border: '1px solid #d1d5db', fontFamily: 'inherit', fontSize: '14px', lineHeight: '1.6', resize: 'vertical' }} />
                    <div style={{ display: 'flex', gap: '8px', marginTop: '12px' }}>
                      <button onClick={() => handleEdit(post.post_id)} style={{ padding: '8px 16px', borderRadius: '6px', border: 'none', background: '#7c3aed', color: '#fff', cursor: 'pointer' }}>Save & Approve</button>
                      <button onClick={() => setEditingId(null)} style={{ padding: '8px 16px', borderRadius: '6px', border: '1px solid #d1d5db', background: '#fff', cursor: 'pointer' }}>Cancel</button>
                    </div>
                  </div>
                ) : (
                  <div>
                    {post.title && <div style={{ fontSize: '16px', fontWeight: 600, color: '#1f2937', marginBottom: '6px' }}>{post.title}</div>}
                    <p style={{ fontSize: '14px', lineHeight: '1.7', color: '#374151', whiteSpace: 'pre-wrap' }}>{post.content}</p>
                    {filter === 'pending' && (
                      <div style={{ display: 'flex', gap: '8px', marginTop: '16px' }}>
                        <button onClick={() => handleApprove(post.post_id)} style={{ padding: '8px 16px', borderRadius: '6px', border: 'none', background: '#10b981', color: '#fff', cursor: 'pointer' }}>✅ Approve</button>
                        <button onClick={() => { setEditingId(post.post_id); setEditTitle(post.title || ''); setEditContent(post.content); }} style={{ padding: '8px 16px', borderRadius: '6px', border: '1px solid #d1d5db', background: '#fff', cursor: 'pointer' }}>✏️ Edit</button>
                        <button onClick={() => handleReject(post.post_id)} style={{ padding: '8px 16px', borderRadius: '6px', border: 'none', background: '#ef4444', color: '#fff', cursor: 'pointer' }}>❌ Reject</button>
                      </div>
                    )}
                    {filter === 'approved' && (
                      <button onClick={() => { setEditingId(post.post_id); setEditTitle(post.title || ''); setEditContent(post.content); }} style={{ marginTop: '12px', padding: '6px 12px', borderRadius: '6px', border: '1px solid #d1d5db', background: '#fff', cursor: 'pointer', fontSize: '13px' }}>✏️ Edit</button>
                    )}
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default ContentStudio;
